export const MEDICATION_CLASSIFICATIONS = [
  { value: '61', label: 'ADHD/ANTI-NARCOLEPSY/ANTI-OBESITY/ANOREXIANTS' },
  { value: '20', label: 'ALLERGENIC EXTRACTS/BIOLOGICALS MISC' },
  { value: '95', label: 'ALTERNATIVE MEDICINES' },
  { value: '14', label: 'AMEBICIDES' },
  { value: '07', label: 'AMINOGLYCOSIDES' },
  { value: '66', label: 'ANALGESICS - ANTI-INFLAMMATORY' },
  { value: '64', label: 'ANALGESICS - NonNarcotic' },
  { value: '65', label: 'ANALGESICS - OPIOID' },
  { value: '23', label: 'ANDROGENS-ANABOLIC' },
  { value: '89', label: 'ANORECTAL AND RELATED PRODUCTS' },
  { value: '48', label: 'ANTACIDS' },
  { value: '15', label: 'ANTHELMINTICS' },
  { value: '16', label: 'ANTI-INFECTIVE AGENTS - MISC.' },
  { value: '32', label: 'ANTIANGINAL AGENTS' },
  { value: '57', label: 'ANTIANXIETY AGENTS' },
  { value: '35', label: 'ANTIARRHYTHMICS' },
  { value: '44', label: 'ANTIASTHMATIC AND BRONCHODILATOR AGENTS' },
  { value: '83', label: 'ANTICOAGULANTS' },
  { value: '72', label: 'ANTICONVULSANTS' },
  { value: '58', label: 'ANTIDEPRESSANTS' },
  { value: '27', label: 'ANTIDIABETICS' },
  { value: '47', label: 'ANTIDIARRHEAL/PROBIOTIC AGENTS' },
  { value: '93', label: 'ANTIDOTES AND SPECIFIC ANTAGONISTS' },
  { value: '50', label: 'ANTIEMETICS' },
  { value: '11', label: 'ANTIFUNGALS' },
  { value: '41', label: 'ANTIHISTAMINES' },
  { value: '39', label: 'ANTIHYPERLIPIDEMICS' },
  { value: '36', label: 'ANTIHYPERTENSIVES' },
  { value: '13', label: 'ANTIMALARIALS' },
  { value: '76', label: 'ANTIMYASTHENIC/CHOLINERGIC AGENTS' },
  { value: '09', label: 'ANTIMYCOBACTERIAL AGENTS' },
  { value: '21', label: 'ANTINEOPLASTICS AND ADJUNCTIVE THERAPIES' },
  { value: '73', label: 'ANTIPARKINSON AND RELATED THERAPY AGENTS' },
  { value: '59', label: 'ANTIPSYCHOTICS/ANTIMANIC AGENTS' },
  { value: '92', label: 'ANTISEPTICS & DISINFECTANTS' },
  { value: '12', label: 'ANTIVIRALS' },
  { value: '33', label: 'BETA BLOCKERS' },
  { value: '34', label: 'CALCIUM CHANNEL BLOCKERS' },
  { value: '31', label: 'CARDIOTONICS' },
  { value: '40', label: 'CARDIOVASCULAR AGENTS - MISC.' },
  { value: '02', label: 'CEPHALOSPORINS' },
  { value: '96', label: 'CHEMICALS' },
  { value: '25', label: 'CONTRACEPTIVES' },
  { value: '22', label: 'CORTICOSTEROIDS' },
  { value: '43', label: 'COUGH/COLD/ALLERGY' },
  { value: '90', label: 'DERMATOLOGICALS' },
  { value: '94', label: 'DIAGNOSTIC PRODUCTS' },
  { value: '81', label: 'DIETARY PRODUCTS/DIETARY MANAGEMENT PRODUCTS' },
  { value: '51', label: 'DIGESTIVE AIDS' },
  { value: '37', label: 'DIURETICS' },
  { value: '30', label: 'ENDOCRINE AND METABOLIC AGENTS - MISC.' },
  { value: '24', label: 'ESTROGENS' },
  { value: '05', label: 'FLUOROQUINOLONES' },
  { value: '52', label: 'GASTROINTESTINAL AGENTS - MISC.' },
  { value: '70', label: 'GENERAL ANESTHETICS' },
  { value: '56', label: 'GENITOURINARY AGENTS - MISCELLANEOUS' },
  { value: '68', label: 'GOUT AGENTS' },
  { value: '85', label: 'HEMATOLOGICAL AGENTS - MISC.' },
  { value: '82', label: 'HEMATOPOIETIC AGENTS' },
  { value: '84', label: 'HEMOSTATICS' },
  { value: '60', label: 'HYPNOTICS/SEDATIVES/SLEEP DISORDER AGENTS' },
  { value: '46', label: 'LAXATIVES' },
  { value: '69', label: 'LOCAL ANESTHETICS-Parenteral' },
  { value: '03', label: 'MACROLIDES' },
  { value: '97', label: 'MEDICAL DEVICES AND SUPPLIES' },
  { value: '67', label: 'MIGRAINE PRODUCTS' },
  { value: '79', label: 'MINERALS & ELECTROLYTES' },
  { value: '99', label: 'MISCELLANEOUS THERAPEUTIC CLASSES' },
  { value: '88', label: 'MOUTH/THROAT/DENTAL AGENTS' },
  { value: '78', label: 'MULTIVITAMINS' },
  { value: '75', label: 'MUSCULOSKELETAL THERAPY AGENTS' },
  { value: '42', label: 'NASAL AGENTS - SYSTEMIC AND TOPICAL' },
  { value: '74', label: 'NEUROMUSCULAR AGENTS' },
  { value: '80', label: 'NUTRIENTS' },
  { value: '86', label: 'OPHTHALMIC AGENTS' },
  { value: '87', label: 'OTIC AGENTS' },
  { value: '29', label: 'OXYTOCICS' },
  { value: '19', label: 'PASSIVE IMMUNIZING AND TREATMENT AGENTS' },
  { value: '01', label: 'PENICILLINS' },
  { value: '98', label: 'PHARMACEUTICAL ADJUVANTS' },
  { value: '26', label: 'PROGESTINS' },
  { value: '62', label: 'PSYCHOTHERAPEUTIC AND NEUROLOGICAL AGENTS - MISC.' },
  { value: '45', label: 'RESPIRATORY AGENTS - MISC.' },
  { value: '08', label: 'SULFONAMIDES' },
  { value: '04', label: 'TETRACYCLINES' },
  { value: '28', label: 'THYROID AGENTS' },
  { value: '18', label: 'TOXOIDS' },
  { value: '49', label: 'ULCER DRUGS/ANTISPASMODICS/ANTICHOLINERGICS' },
  { value: '54', label: 'URINARY ANTISPASMODICS' },
  { value: '17', label: 'VACCINES' },
  { value: '55', label: 'VAGINAL AND RELATED PRODUCTS' },
  { value: '38', label: 'VASOPRESSORS' },
  { value: '77', label: 'VITAMINS' },
];
